import script from "./WagerStatusFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./WagerStatusFilters.vue?vue&type=script&setup=true&lang=ts"

import "./WagerStatusFilters.vue?vue&type=style&index=0&id=4af29abe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4af29abe"]])

export default __exports__